import history from '../../history';
import Promise from 'bluebird';
import axiosInstance from '../utils/axios';
import debug from 'debug';

const log = debug('circleblack:redux:config');

let config = {};
let loaded = false;

log('Config', config);

/* --- actions ---*/
const GET_CONFIG = 'GET_CONFIG';

export const _getConfig = force => dispatch => (loaded && !force) ? Promise.resolve(dispatch({type: GET_CONFIG, config}))
  : axiosInstance.get('/user/config')
    .then(function setConfig(res) {
      dispatch({
        type: GET_CONFIG,
        config: res.data,
      });
    })
    .catch(err => {
      log('failed gathering config', err);
      history.push('/login');
    });

/* --- reducer ---*/
export default function reducer(state = config, action) {
  let newState = {...state};

  switch (action.type) {
    case GET_CONFIG:
      config = action.config;
      newState = action.config;
      loaded = true;
      break;
    default:
      return state;
  }
  return newState;
}
